import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import PageTransition from "../components/PageTransition";
import PullToRefresh from "../components/PullToRefresh";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function MainLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(
    () => typeof window !== "undefined" && window.innerWidth >= 744
  );
  const [isPageLoading, setIsPageLoading] = useState(false);
  const location = useLocation();

  const handleContentClick = () => {
    if (sidebarOpen && window.innerWidth < 744) {
      setSidebarOpen(false);
    }
  };

  useEffect(() => {
    if (window.innerWidth < 744) {
      setSidebarOpen(false);
    }
  }, [location.pathname]);

  return (
    <>
      {/* Toast Container */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        style={{ 
          position: 'fixed',
          top: '20px',
          right: '20px',
          zIndex: 999999
        }}
        toastClassName="rounded-xl shadow-lg"
        bodyClassName="text-sm font-medium"
        progressClassName="bg-primary"
      />
      
      {/* Main Container — safe-area untuk iPad/notch/home indicator */}
      <div className="min-h-[100dvh] min-h-screen bg-[#F3F4FB] pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)]">

        {/* Sidebar */}
        <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
        
        {/* Content Area */}
        <div
          className={`layout-transition ${sidebarOpen ? "tablet:pl-[5.6rem]" : ""}`}
          onClick={handleContentClick}
        >
          {/* Header */}
          <Header setSidebarOpen={setSidebarOpen} sidebarOpen={sidebarOpen} />
          <PullToRefresh />
          
          {/* Loading Progress Bar */}
          {isPageLoading && (
            <div className="fixed top-0 left-0 right-0 z-50">
              <div className="h-0.5 bg-primary overflow-hidden">
                <div className="h-full bg-accent progress-bar-slide" />
              </div>
            </div>
          )}
          
          {/* Main Content — padding tablet/iPad mini lebih nyaman */}
          <main className="flex-1 relative min-h-[calc(100dvh-3.5rem)] min-h-[calc(100vh-3.5rem)] overflow-x-hidden">
            <PageTransition>
              <div className="py-4 px-3 sm:py-5 sm:px-4 tablet:py-6 tablet:px-5 md:px-6 lg:px-8">
                <div className="mx-auto w-full max-w-7xl">
                  <Outlet />
                </div>
              </div>
            </PageTransition>
          </main>
        </div>

        {/* Loading Overlay */}
        {isPageLoading && (
          <div className="fixed inset-0 bg-white/5 z-30 pointer-events-none" />
        )}
      </div>
    </>
  );
}

export default MainLayout;